
import React from 'react';

interface SummaryLineItemProps {
  label: string;
  amount: number;
  description?: string;
  recurring?: boolean;
  isProcessingFee?: boolean;
  includesFee?: boolean;
  showFeeDetail?: boolean;
  bold?: boolean;
  large?: boolean;
  highlight?: boolean;
  periodSuffix?: string;
}

const SummaryLineItem: React.FC<SummaryLineItemProps> = ({ 
  label,
  amount,
  description = '',
  recurring = false,
  isProcessingFee = false,
  includesFee = false,
  showFeeDetail = false,
  bold = false,
  large = false,
  highlight = false,
  periodSuffix = ''
}) => {
  const labelClassName = `
    ${bold ? 'font-bold' : 'font-medium'} 
    ${large ? 'text-lg' : 'text-sm'} 
    ${highlight ? 'text-theme-highlight' : 'text-theme-text'}
  `;
  return (
    <div className="flex justify-between text-sm">
      <div className={labelClassName}>
        {label}
        {description && (
          <div className="text-xs text-theme-secondary">
             {description}
          </div>
        )}
        {includesFee && <span className="text-xs text-theme-secondary ml-1">*</span>}
      </div>
      <div className="font-medium">
        {`$${amount.toFixed(2)}`}{periodSuffix && (
          <span className="text-sm">{periodSuffix}</span>
        )}
        {recurring && <span className="text-xs text-theme-secondary">/mo</span>}
        {showFeeDetail && includesFee && (
          <span className="text-xs text-theme-secondary ml-1">
            (includes fees)
          </span>
        )}
      </div>
    </div>
  );
};

export default SummaryLineItem;
